/*
 * @@Description: 创建滚动条
 * @@Author: MuYang
 * @Date: 2021-09-13 10:48:04
 * @LastEditTime: 2021-09-30 11:32:05
 */

import { changeMode, MODE_TYPES, MODE } from './shared'
import { addClass, setStyle } from '../../../../../../utils/dom'

// 绑定elBar事件
function bindElBarScroll (elBar, $el, config) {
  const { client, directionX, OFFSETSIZE, SCROLLSIZE } = config
  const { [OFFSETSIZE]: offsetSize, [SCROLLSIZE]: scrollSize } = $el
  let $elBar = elBar
  let clickThumbAxis
  $elBar.addEventListener('mousedown', event => {
    const offset = Math.abs(
      event.target.getBoundingClientRect()[directionX] - event[client]
    )
    const thumbHalf = $elBar.firstChild[OFFSETSIZE] / 2
    const thumbPositionPercentage = ((offset - thumbHalf) * 100) / offsetSize
    $el.scrollLeft = (thumbPositionPercentage * scrollSize) / 100
  })

  const elBarMove = event => {
    if (MODE === MODE_TYPES.DOWN || MODE === MODE_TYPES.SHOW_DOWN) {
      const prevPage = clickThumbAxis
      if (!prevPage) return
      const offset =
        ($elBar.getBoundingClientRect()[directionX] - event[client]) * -1
      //获得点击位置与 滚动条顶部 之间的距离
      const thumbClickPosition = targetNode[SCROLLSIZE] - prevPage
      //获得滚动条所处的百分比位置
      const thumbPositionPercentage =
        ((offset - thumbClickPosition) * 100) / $elBar[SCROLLSIZE]
      $el.scrollLeft = (thumbPositionPercentage * scrollSize) / 100
    }
  }

  const elBarUp = () => {
    clickThumbAxis = 0
    if (MODE === MODE_TYPES.DOWN) {
      changeMode(MODE_TYPES.WAIT)
      $elBar.changeScrollState()
      return
    }
    if (MODE === MODE_TYPES.SHOW_DOWN) {
      changeMode(MODE_TYPES.SHOW)
    }
    setStyle(document.body, 'user-select', 'auto')
    document.removeEventListener('mousemove', elBarMove)
    document.removeEventListener('mouseup', elBarUp)
  }

  const targetNode = $elBar?.firstChild
  // 按住滚动条
  targetNode.addEventListener('mousedown', event => {
    event.stopImmediatePropagation()
    event.stopPropagation()
    clickThumbAxis =
      event.currentTarget[OFFSETSIZE] -
      (event[client] - event.currentTarget.getBoundingClientRect()[directionX])
    changeMode(MODE_TYPES.SHOW_DOWN)
    $elBar.changeScrollState('visible')
    setStyle(document.body, 'user-select', 'none')
    // 滚动鼠标
    document.addEventListener('mousemove', elBarMove)
    document.addEventListener('mouseup', elBarUp)
    document.onselectstart = false
  })
}

/* 创建滚动条 */
function _createBar (type) {
  const bar = document.createElement('div')
  const barStrip = document.createElement('div')
  addClass(barStrip, 'sy-scroll-bar-strip')
  addClass(bar, `sy-scroll-bar sy-scroll-bar-${type}`)
  bar.appendChild(barStrip)
  return bar
}

/* 插入滚动条 */
function _insertBar (parentEl, elBar) {
  parentEl.appendChild(elBar)
}

export default function createBar (parentEl, type, el, config) {
  const elBar = _createBar(type)
  _insertBar(parentEl, elBar)
  bindElBarScroll(elBar, el, config)
  elBar.changeScrollState = function (visibility = '') {
    // this.style.visibility = visibility
  }
  return elBar
}
